import { FC, SVGProps } from 'react'

const SendIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.32821 7.86731L3.25557 7.17641C1.0852 6.45296 0 6.09123 0 5.4265C0 4.76174 1.08519 4.40001 3.25558 3.67656L11.1073 1.05931C12.6345 0.550259 13.398 0.29574 13.8011 0.698805C14.2041 1.10186 13.9496 1.86544 13.4406 3.39258L10.8233 11.2443C10.0999 13.4147 9.73816 14.4999 9.07336 14.4999C8.40866 14.4999 8.04693 13.4147 7.32338 11.2443L6.63258 9.17164L10.6478 5.15637C11.008 4.79619 11.008 4.21221 10.6478 3.85203C10.2877 3.49185 9.70367 3.49185 9.34351 3.85203L5.32821 7.86731Z"
      fill="currentColor"
    />
  </svg>
)

export default SendIcon
